export class CreatePersonDocumentModel {
  public TipoDocId = 0
  public PessoaId = 0
  public Descricao = ''
  public Arquivo: File | null = null

  public toFormData(): FormData {
    const formData = new FormData()
    formData.append('Descricao', convertString(this.Descricao))
    formData.append('TipoDocId', convertString(this.TipoDocId))
    formData.append('PessoaId', convertString(this.PessoaId))
    if (this.Arquivo) {
      formData.append('Arquivo', this.Arquivo)
    }
    return formData
  }
}

export class EditPersonDocumentModel {
  public id = 0
  public TipoDocId = 0
  public PessoaId = 0
  public Descricao = ''
  public Arquivo: File | null = null

  public toFormData(): FormData {
    const formData = new FormData()
    formData.append('id', convertString(this.id))
    formData.append('Descricao', convertString(this.Descricao))
    formData.append('TipoDocId', convertString(this.TipoDocId))
    formData.append('PessoaId', convertString(this.PessoaId))
    if (this.Arquivo) {
      formData.append('Arquivo', this.Arquivo)
    }
    return formData
  }
}

export class DeletePersonDocumentModel {
  public id = 0
  public descricao = ''
}

export class SearchPersonDocumentModel {
  public descricao = ''
}

export class CreatePersonDocumentResponse {
  public response: any
}

export class EditPersonDocumentResponse {
  public response: any
}

export class DeletePersonDocumentResponse {
  public response: any
}

export class PagedPersonDocumentResponse {
  public response: any
}

function convertString(value: any) {
  return value ? value.toString() : ''
}
